// SecurityBasics.js
import React from 'react';
import './News.css';

export default function SecurityBasics() {
  return (
    <div className="page-container">
      <h1 className="news-title">Website Safety & Security for Parents</h1>
      <p className="news-meta">Published by Mohit Singh - August 19, 2025</p>

      <p>
        At ChronoTech Robotics, the safety of your family is our top priority. Whether your child is registering for a class or exploring our guides,
        we take serious steps to protect all personal data and ensure a safe online experience.
      </p>

      <p>
        Our platform is powered by secure cloud infrastructure and built with parental peace of mind in mind. We use Amazon Web Services (AWS) to handle all user authentication,
        database management, and payment processing — meaning your data never passes through unsecured servers or third-party plugins.
      </p>

      <p>
        When a user signs up for a class or submits a form, their information is encrypted and stored securely in AWS DynamoDB with strict access controls.
        All pages that collect sensitive data use HTTPS encryption by default.
      </p>

      <p>
        We also use verified payment processing through <strong>Stripe</strong> for all transactions, and we do not store or process payment information directly on our site.
        Every signup process is followed by a confirmation email, and support is available if you ever need help.
      </p>

      <p>
        As our platform grows, we’re working on adding multi-factor authentication for admin accounts, CAPTCHA protection for public forms, and parent dashboards where you can manage
        your child’s profile and registrations safely.
      </p>

      <p>
        If you have questions about how we store or use your data, feel free to reach out. We want you to feel confident using ChronoTech Robotics — because online learning should be safe, transparent, and empowering.
      </p>

      <p className="news-signoff">– Mohit Singh, Founder</p>
    </div>
  );
}
